<div class="card-container mb-27 mct-gap-10">
  <div class="mct-grid mct-cols-1-1-1 mct-gap-0-27">
    <div></div>
    <div class="billing-col-2-span-2">
      <div *ngIf="+selectedUpdateMethod == 3">
        {{ 'revenue.billing-amount-update.use-arc-if' | translate | ucfirst }}
      </div>
    </div>
    <div>
      <p-select
        #updateMethod
        [options]="updateMethods"
        appendTo="body"
        [(ngModel)]="selectedUpdateMethod"
        placeholder="{{ 'revenue.billing-amount-update.select-method' | translate | titlecase }}"
        [style]="{ width: '100%' }"
      ></p-select>
    </div>
    <div [hidden]="+selectedUpdateMethod != 1">
      <div class="input-group">
        <wl-currency-symbol class="input-group-addon"></wl-currency-symbol>
        <input type="number" class="form-control t-ar" [(ngModel)]="searchParams.FlatAmount" />
      </div>
    </div>
    <div [hidden]="+selectedUpdateMethod != 2">
      <div class="input-group">
        <span class="input-group-addon">%</span>
        <input type="number" class="form-control t-ar" [(ngModel)]="searchParams.Percentage" />
      </div>
    </div>
    <div [hidden]="+selectedUpdateMethod != 3" class="billing-col-2-span-2">
      <p-select
        [options]="pricingCalcs"
        optionLabel="Descr"
        optionValue="ArcID"
        [style]="{ width: '100%' }"
        appendTo="body"
        [(ngModel)]="selectedPricingCalc"
      ></p-select>
    </div>
    <div [hidden]="+selectedUpdateMethod != 4" class="billing-col-2-span-2"></div>
    <div [hidden]="+selectedUpdateMethod > 1"></div>
  </div>
  <div class="mct-flex mct-justify-end mct-items-stretch">
    <div class="mct-flex mct-col mct-gap-12">
      <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="previewClick()" [disabled]="isSaving">
        {{ 'revenue.billing-amount-update.preview' | translate | uppercase }}
      </button>
      <div class="mct-flex mct-row mct-gap-8 mct-justify-start mct-items-center">
        <p-checkbox [(ngModel)]="searchParams.RoundToWhole" inputId="chk_rhrtek" binary="true"></p-checkbox>
        <label for="chk_rhrtek">Round to nearest dollar</label>
      </div>
    </div>
  </div>
</div>
<div [hidden]="!isSaving" class="w-100 t-ar mb-10">
  <span style="color: red">{{ 'revenue.billing-amount-update.close-warning' | translate }}</span>
</div>
<div
  *ngIf="searchResult?.Result && searchResult?.TotalCount > 0"
  class="mb-27 mct-flex mct-row mct-justify-between mct-items-stretch"
>
  <div>
    <action-button
      [label]="'revenue.billing-amount-update.actions.label' | translate | uppercase"
      [items]="previewActionOptions"
      [menuStyle]="{ width: '250px' }"
    >
    </action-button>
  </div>
  <div class="mct-flex mct-row mct-justify-end mct-items-stretch mct-gap-10">
    <div>
      <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="cancel()" [disabled]="isSaving">
        {{ 'common.cancel' | translate | uppercase }}
      </button>
    </div>
    <div>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-primary"
        (click)="persistUpdates()"
        [disabled]="isSaving"
        [hidden]="saveCompleted"
      >
        {{ 'revenue.billing-amount-update.update-amounts' | translate | uppercase }}
        <wl-busy [show]="isSaving"></wl-busy>
      </button>
      <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="cancel()" *ngIf="saveCompleted" [hidden]="!saveCompleted">
        {{ 'common.continue' | translate | uppercase }}
      </button>
    </div>
  </div>
</div>
<div *ngIf="!searchResult?.Result || searchResult?.TotalCount == 0" class="mb-27 mct-flex mct-row mct-justify-end mct-items-stretch">
  <div>
    <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="cancel()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
  </div>
</div>
<div>
  <p-table [showGridlines]="true"
    [rows]="searchParams ? searchParams.PageSize : 20"
    [value]="searchResult?.Result"
    [totalRecords]="searchResult?.TotalCount"
    (onLazyLoad)="lazyLoad($event)"
    [paginator]="true"
    [lazy]="true"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th [style]="{ width: '55px', textAlign: 'center' }">
          <p-checkbox binary="true" [(ngModel)]="selectAll" (onChange)="onSelectAllChange()"></p-checkbox>
        </th>
        <th>{{ 'revenue.billing-amount-update.profile' | translate | titlecase }}</th>
        <th>{{ 'revenue.billing-amount-update.revenue-item' | translate | titlecase }}</th>
        <th [style]="{ textAlign: 'right' }">{{ 'revenue.billing-amount-update.amount-per-cycle' | translate | titlecase }}</th>
        <th [style]="{ textAlign: 'right' }">{{ 'revenue.billing-amount-update.new-amount-per-cycle' | translate | titlecase }}</th>
        <th>{{ 'revenue.billing-amount-update.billing-cycle' | translate | titlecase }}</th>
      </tr>
    </ng-template>
    <ng-template let-billing pTemplate="body">
      <tr>
        <td [style]="{ textAlign: 'center' }">
          <p-checkbox binary="true" [ngModel]="itemIsSelected(billing)" (ngModelChange)="onRowSelectionChange(billing)"></p-checkbox>
        </td>
        <td>{{ billing.ProfileReportName }}</td>
        <td>{{ billing.RevenueItemName }}</td>
        <td [style]="{ textAlign: 'right' }">{{ billing.AmountPerCycle | currency }}</td>
        <td [style]="{ textAlign: 'right' }">{{ billing.NewAmountPerCycle | currency }}</td>
        <td>{{ billing.BillingCycle }}</td>
      </tr>
    </ng-template>
  </p-table>
  <p-progressSpinner *ngIf="loading"></p-progressSpinner>
</div>
